var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "mobile-navigation",
      class: { open: _vm.isMobileNavigationOpen },
    },
    [
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.isNavigationInitialized,
              expression: "isNavigationInitialized",
            },
          ],
        },
        [
          _c("div", { staticClass: "d-flex m-3 mt-4" }, [
            _vm._m(0),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass:
                  "flex-fill align-items-center justify-content-end d-flex",
              },
              [
                _c(
                  "div",
                  {
                    on: {
                      click: function ($event) {
                        return _vm.closeNavigation()
                      },
                    },
                  },
                  [
                    _c("i", {
                      staticClass: "fa fa-close",
                      staticStyle: { "font-size": "30px" },
                    }),
                  ]
                ),
              ]
            ),
          ]),
          _vm._v(" "),
          _c(
            "ul",
            {
              directives: [{ name: "menu", rawName: "v-menu" }],
              staticClass: "mainmenu w-100 p-0 m-0 menu-active",
              attrs: { id: "menu-1" },
            },
            [
              _vm.dataContainer1.parent
                ? _c(
                    "li",
                    {
                      staticClass: "ddown",
                      on: {
                        click: function ($event) {
                          return _vm.slideTo(
                            (_vm.dataContainer1.parent &&
                              _vm.dataContainer1.parent.parent) ||
                              null,
                            true
                          )
                        },
                      },
                    },
                    [_vm._m(1)]
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm._l(_vm.dataContainer1.categories, function (category, index) {
                return _c(
                  "li",
                  {
                    staticClass: "ddown",
                    class: [
                      {
                        "animate__animated animate__fadeInUp":
                          _vm.isMobileNavigationOpen,
                      },
                      "category_" + category.id,
                      "delay-" + index,
                    ],
                  },
                  [
                    _c(
                      "a",
                      { attrs: { href: _vm.getCategoryUrl(category.url) } },
                      [_vm._v(_vm._s(category.details[0].name))]
                    ),
                    _vm._v(" "),
                    category.childCount
                      ? _c(
                          "span",
                          {
                            staticClass: "nav-direction",
                            on: {
                              click: function ($event) {
                                return _vm.slideTo(category)
                              },
                            },
                          },
                          [
                            _c("i", {
                              staticClass: "fa fa-lg fa-caret-right",
                              attrs: { "aria-hidden": "true" },
                            }),
                          ]
                        )
                      : _vm._e(),
                  ]
                )
              }),
              _vm._v(" "),
              _vm.dataContainer1.categories[0]
                ? _vm._l(
                    _vm.dataContainer1.categories[0].siblingCount -
                      _vm.dataContainer1.categories.length,
                    function (number) {
                      return _c("li", { staticClass: "ddown" }, [
                        _c("span", {
                          staticClass: "nav-placeholder m-3",
                          style: { width: Math.random() * 20 + 60 + "%" },
                        }),
                      ])
                    }
                  )
                : _vm.dataContainer1.parent
                ? _vm._l(
                    _vm.dataContainer1.parent.childCount,
                    function (number) {
                      return _c("li", { staticClass: "ddown" }, [
                        _c("span", {
                          staticClass: "nav-placeholder m-3",
                          style: { width: Math.random() * 20 + 60 + "%" },
                        }),
                      ])
                    }
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.breadcrumbs.length == 0 && _vm.langs.length > 1
                ? [
                    _c(
                      "li",
                      {
                        class: [
                          {
                            "animate__animated animate__fadeInUp":
                              _vm.isMobileNavigationOpen,
                          },
                          "delay-5",
                        ],
                      },
                      [
                        _c(
                          "span",
                          {
                            staticClass:
                              "nav-direction d-flex align-items-center mHeader",
                          },
                          [
                            _c(
                              "div",
                              { staticClass: "flex-fill text-center" },
                              [
                                _vm._v(
                                  "\n                      " +
                                    _vm._s(
                                      _vm.$translate(
                                        "BeckerTech::Template.headerLangs"
                                      )
                                    ) +
                                    "\n                  "
                                ),
                              ]
                            ),
                          ]
                        ),
                      ]
                    ),
                    _vm._v(" "),
                    _vm.langs.length > 1
                      ? _c(
                          "li",
                          {
                            class: [
                              {
                                "animate__animated animate__fadeInUp":
                                  _vm.isMobileNavigationOpen,
                              },
                              "delay-6",
                            ],
                          },
                          [
                            _c("a", { attrs: { href: _vm.urlDE } }, [
                              _c("img", {
                                attrs: {
                                  src: "https://cdn02.plentymarkets.com/iccu94qfd9gw/frontend/shop/icons/Lang/de.png",
                                },
                              }),
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm.$translate(
                                      "BeckerTech::Template.german"
                                    )
                                  ) +
                                  "\n              "
                              ),
                            ]),
                          ]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.langs.indexOf("en") > -1
                      ? _c(
                          "li",
                          {
                            class: [
                              {
                                "animate__animated animate__fadeInUp":
                                  _vm.isMobileNavigationOpen,
                              },
                              "delay-7",
                            ],
                          },
                          [
                            _c("a", { attrs: { href: _vm.urlEN } }, [
                              _c("img", {
                                attrs: {
                                  src: "https://cdn02.plentymarkets.com/iccu94qfd9gw/frontend/shop/icons/Lang/en.png",
                                },
                              }),
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm.$translate(
                                      "BeckerTech::Template.englisch"
                                    )
                                  ) +
                                  "\n              "
                              ),
                            ]),
                          ]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.langs.indexOf("it") > -1
                      ? _c(
                          "li",
                          {
                            class: [
                              {
                                "animate__animated animate__fadeInUp":
                                  _vm.isMobileNavigationOpen,
                              },
                              "delay-8",
                            ],
                          },
                          [
                            _c("a", { attrs: { href: _vm.urlIT } }, [
                              _c("img", {
                                attrs: {
                                  src: "https://cdn02.plentymarkets.com/iccu94qfd9gw/frontend/shop/icons/Lang/it.png",
                                },
                              }),
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm.$translate(
                                      "BeckerTech::Template.italian"
                                    )
                                  ) +
                                  "\n              "
                              ),
                            ]),
                          ]
                        )
                      : _vm._e(),
                  ]
                : _vm._e(),
            ],
            2
          ),
          _vm._v(" "),
          _c(
            "ul",
            {
              directives: [{ name: "menu", rawName: "v-menu" }],
              staticClass: "mainmenu w-100 p-0 m-0",
              attrs: { id: "menu-2" },
            },
            [
              _vm.dataContainer2.parent
                ? _c(
                    "li",
                    {
                      staticClass: "ddown",
                      on: {
                        click: function ($event) {
                          return _vm.slideTo(
                            (_vm.dataContainer2.parent &&
                              _vm.dataContainer2.parent.parent) ||
                              null,
                            true
                          )
                        },
                      },
                    },
                    [_vm._m(2)]
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm._l(_vm.dataContainer2.categories, function (category) {
                return _c("li", { staticClass: "ddown" }, [
                  _c(
                    "a",
                    { attrs: { href: _vm.getCategoryUrl(category.url) } },
                    [_vm._v(_vm._s(category.details[0].name))]
                  ),
                  _vm._v(" "),
                  category.childCount
                    ? _c(
                        "span",
                        {
                          staticClass: "nav-direction",
                          on: {
                            click: function ($event) {
                              return _vm.slideTo(category)
                            },
                          },
                        },
                        [
                          _c("i", {
                            staticClass: "fa fa-lg fa-caret-right",
                            attrs: { "aria-hidden": "true" },
                          }),
                        ]
                      )
                    : _vm._e(),
                ])
              }),
              _vm._v(" "),
              _vm.dataContainer2.categories[0]
                ? _vm._l(
                    _vm.dataContainer2.categories[0].siblingCount -
                      _vm.dataContainer2.categories.length,
                    function (number) {
                      return _c("li", { staticClass: "ddown" }, [
                        _c("span", {
                          staticClass: "nav-placeholder m-3",
                          style: { width: Math.random() * 20 + 60 + "%" },
                        }),
                      ])
                    }
                  )
                : _vm.dataContainer2.parent
                ? _vm._l(
                    _vm.dataContainer2.parent.childCount,
                    function (number) {
                      return _c("li", { staticClass: "ddown" }, [
                        _c("span", {
                          staticClass: "nav-placeholder m-3",
                          style: { width: Math.random() * 20 + 60 + "%" },
                        }),
                      ])
                    }
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.breadcrumbs.length == 0 && _vm.langs.length > 1
                ? [
                    _c(
                      "li",
                      {
                        class: [
                          {
                            "animate__animated animate__fadeInUp":
                              _vm.isMobileNavigationOpen,
                          },
                          "delay-5",
                        ],
                      },
                      [
                        _c(
                          "span",
                          {
                            staticClass:
                              "nav-direction d-flex align-items-center mHeader",
                          },
                          [
                            _c(
                              "div",
                              { staticClass: "flex-fill text-center" },
                              [
                                _vm._v(
                                  "\n                        " +
                                    _vm._s(
                                      _vm.$translate(
                                        "BeckerTech::Template.headerLangs"
                                      )
                                    ) +
                                    "\n                    "
                                ),
                              ]
                            ),
                          ]
                        ),
                      ]
                    ),
                    _vm._v(" "),
                    _vm.langs.length > 1
                      ? _c(
                          "li",
                          {
                            class: [
                              {
                                "animate__animated animate__fadeInUp":
                                  _vm.isMobileNavigationOpen,
                              },
                              "delay-6",
                            ],
                          },
                          [
                            _c("a", { attrs: { href: _vm.urlDE } }, [
                              _c("img", {
                                attrs: {
                                  src: "https://cdn02.plentymarkets.com/iccu94qfd9gw/frontend/shop/icons/Lang/de.png",
                                },
                              }),
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm.$translate(
                                      "BeckerTech::Template.german"
                                    )
                                  ) +
                                  "\n                "
                              ),
                            ]),
                          ]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.langs.indexOf("en") > -1
                      ? _c(
                          "li",
                          {
                            class: [
                              {
                                "animate__animated animate__fadeInUp":
                                  _vm.isMobileNavigationOpen,
                              },
                              "delay-7",
                            ],
                          },
                          [
                            _c("a", { attrs: { href: _vm.urlEN } }, [
                              _c("img", {
                                attrs: {
                                  src: "https://cdn02.plentymarkets.com/iccu94qfd9gw/frontend/shop/icons/Lang/en.png",
                                },
                              }),
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm.$translate(
                                      "BeckerTech::Template.englisch"
                                    )
                                  ) +
                                  "\n                "
                              ),
                            ]),
                          ]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.langs.indexOf("it") > -1
                      ? _c(
                          "li",
                          {
                            class: [
                              {
                                "animate__animated animate__fadeInUp":
                                  _vm.isMobileNavigationOpen,
                              },
                              "delay-8",
                            ],
                          },
                          [
                            _c("a", { attrs: { href: _vm.urlIT } }, [
                              _c("img", {
                                attrs: {
                                  src: "https://cdn02.plentymarkets.com/iccu94qfd9gw/frontend/shop/icons/Lang/it.png",
                                },
                              }),
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm.$translate(
                                      "BeckerTech::Template.italian"
                                    )
                                  ) +
                                  "\n                "
                              ),
                            ]),
                          ]
                        )
                      : _vm._e(),
                  ]
                : _vm._e(),
            ],
            2
          ),
        ]
      ),
      _vm._v(" "),
      !_vm.isNavigationInitialized
        ? [
            _c("ul", { staticClass: "breadcrumb" }, [
              _c("li", {
                staticClass: "btn-close",
                on: {
                  click: function ($event) {
                    return _vm.closeNavigation()
                  },
                },
              }),
              _vm._v(" "),
              _vm._m(3),
            ]),
            _vm._v(" "),
            _c("loading-animation"),
          ]
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("a", { staticClass: "flex-fill", attrs: { href: "/" } }, [
      _c("img", {
        staticClass: "img-fluid",
        attrs: {
          src: "https://cdn02.plentymarkets.com/iccu94qfd9gw/frontend/shop/logos/small-white/ebene-1.png",
        },
      }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("span", { staticClass: "nav-direction btn-up" }, [
      _c("i", {
        staticClass: "fa fa-lg fa-level-up",
        attrs: { "aria-hidden": "true" },
      }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("span", { staticClass: "nav-direction btn-up" }, [
      _c("i", {
        staticClass: "fa fa-lg fa-level-up",
        attrs: { "aria-hidden": "true" },
      }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("li", { staticClass: "breadcrumb-item" }, [
      _c("i", { staticClass: "fa fa-home", attrs: { "aria-hidden": "true" } }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }